import { TaskListStatus } from "./enum-type";
import { Product } from "./product";
import { Subtask } from "./subtask";

export interface TaskList {
    label: string
    id?: string
    codeTournee: string
    startDate: Date
    endDate: Date
    taskListStatus: TaskListStatus
    technicianIds: string[]
    technicianNames?: string[]
    startAddressLine1?: string
    startAddressLine2?: string
    startAddressCity?: string
    startAddressPostalCode?: string
    endAddressLine1?: string
    endAddressLine2?: string
    endAddressCity?: string
    endAddressPostalCode?: string
    vehicleId?: string
    startGeoAddressId?: string
    endGeoAddressId?: string
    startNewUserAddress?: boolean
    endNewUserAddress?: boolean
}

export class TaskListGen {
    // Code tournee
    ct: string
    hct: boolean

    // Date
    d: string
    hd: boolean

    // Technicians
    tec: string[]
    htec: boolean

    // Tasks
    tsk: TaskProducts[]
    htsk: boolean
}

export class TaskListExport {
    tskLists: TaskList[]
}

export class TaskProducts {
    taskName: string
    taskSubject: string
    taskType: string
    taskObs: string
    taskObserv: string
    hto: boolean
    prdts: Product[]
    subtsks: Subtask[]
}

export function getTaskListExport(taskLists: TaskList[]): TaskListExport {
    const taskListExport = new TaskListExport()
    taskListExport.tskLists = taskLists
    return taskListExport
}